import { useEffect } from 'react';
import { useTranscodeJobsStore } from '@/client/store/transcodeJobsStore';
import { TRANSCODE_CONFIG } from '@shared/types';

const { STALL_CHECK_INTERVAL_MS } = TRANSCODE_CONFIG;

/**
 * Hook to periodically re-evaluate stall status for processing transcode jobs.
 * Should be used on the transcode jobs monitoring page.
 *
 * @param enabled - Whether to run the interval (default: true)
 */
export function useStallDetection(enabled = true) {
  const reEvaluateStallStatus = useTranscodeJobsStore((state) => state.reEvaluateStallStatus);
  const processingCount = useTranscodeJobsStore((state) => state.processing.size);

  useEffect(() => {
    // Don't run if disabled or no processing jobs
    if (!enabled || processingCount === 0) {
      return;
    }

    const interval = setInterval(() => {
      reEvaluateStallStatus();
    }, STALL_CHECK_INTERVAL_MS);

    return () => clearInterval(interval);
  }, [enabled, processingCount, reEvaluateStallStatus]);
}
